import React, { Component }  from 'react';
import {showNotification, UPDATE, withDataProvider} from 'react-admin';

class TrackingNumberEditableField extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            isEditing : false,
            tracking_number: this.props.record.tracking_number
        }
    }

    setTrackingNumber = (value) => {
        this.setState({
            tracking_number: value
        })
    }

    setEditing = (isEditing) => {
        this.setState({
            isEditing: isEditing
        })
    }

    updateTrackingNumber = (e) => {

        this.setState({
            isEditing: false
        })

        if(this.props.record.tracking_number !== this.state.tracking_number) {
           const { dataProvider, dispatch, record } = this.props;
           const updatedRecord = { ...record, tracking_number: this.state.tracking_number }; 
           dataProvider(UPDATE, 'stockoutrequests', { id: record.id, data: updatedRecord })
            .then(() => {
                dispatch(showNotification('resources.stockoutrequests.actions.tracking_number_updated'));
            })
            .catch((e) => {
                dispatch(showNotification('resources.stockoutrequests.actions.tracking_number_updated_error', 'warning'));
            });
        }

    }

    keyDownUpdateTrackingNumber = (e) => {
        if (e.key === 'Enter') {
            this.setState({
                isEditing: false
            })

           const { dataProvider, dispatch, record } = this.props;
           const updatedRecord = { ...record, tracking_number: this.state.tracking_number }; 
           dataProvider(UPDATE, 'stockoutrequests', { id: record.id, data: updatedRecord })
            .then(() => {
                dispatch(showNotification('resources.stockoutrequests.actions.tracking_number_updated'));
            })
            .catch((e) => {
                dispatch(showNotification('resources.stockoutrequests.actions.tracking_number_updated_error', 'warning'));
            });
        }
    }

    render() {
        return (
            <div>{this.state.isEditing ? (
                <div
                onBlur={e => this.updateTrackingNumber(e)}
                >
                  <input type="text" name="tracking_number" placeholder="Tracking Number" value={this.state.tracking_number}
                    onChange={e => this.setTrackingNumber(e.target.value)}
                    onKeyDown={e => this.keyDownUpdateTrackingNumber(e)}
                  />
                </div>
              ) : (
                <div
                  onClick={() => this.setEditing(true)}
                >
                  <span>
                    {this.state.tracking_number || "Tracking Number"}
                  </span>
                </div>
              )}
            </div>
        )
    }
};

TrackingNumberEditableField.defaultProps = {
    source: 'tracking_number',
    addLabel: true,
};

export default withDataProvider(TrackingNumberEditableField);